/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lifts: NonNullable<unknown> }} Workout_Share_Analysis_TopInputs */

const en_us2_workout_share_analysis_top = /** @type {(inputs: Workout_Share_Analysis_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`best sets: ${i?.lifts}`)
};

const pt_br2_workout_share_analysis_top = /** @type {(inputs: Workout_Share_Analysis_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`melhores séries: ${i?.lifts}`)
};

const es_419_workout_share_analysis_top = /** @type {(inputs: Workout_Share_Analysis_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`mejores series: ${i?.lifts}`)
};

const pt_pt2_workout_share_analysis_top = /** @type {(inputs: Workout_Share_Analysis_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`melhores séries: ${i?.lifts}`)
};

const fr_fr2_workout_share_analysis_top = /** @type {(inputs: Workout_Share_Analysis_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`meilleures séries : ${i?.lifts}`)
};

const de_de2_workout_share_analysis_top = /** @type {(inputs: Workout_Share_Analysis_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`beste Sätze: ${i?.lifts}`)
};

const it_it2_workout_share_analysis_top = /** @type {(inputs: Workout_Share_Analysis_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`serie migliori: ${i?.lifts}`)
};

/**
* | output |
* | --- |
* | "best sets: {lifts}" |
*
* @param {Workout_Share_Analysis_TopInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_analysis_top = /** @type {((inputs: Workout_Share_Analysis_TopInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Analysis_TopInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_analysis_top(inputs)
	if (locale === "es-419") return es_419_workout_share_analysis_top(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_analysis_top(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_analysis_top(inputs)
	if (locale === "de-DE") return de_de2_workout_share_analysis_top(inputs)
	if (locale === "it-IT") return it_it2_workout_share_analysis_top(inputs)
	return en_us2_workout_share_analysis_top(inputs)
});
export { workout_share_analysis_top as "workout-share.analysis_top" }